import "core-js/stable";
import "regenerator-runtime/runtime";
import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import "./axiosMiddleware";
import "./index.css";
import App from "./App";
import { unregister } from "./registerServiceWorker";
import store from "./store/index";
import "semantic-ui-css/semantic.min.css";

ReactDOM.render(<App store={store} />, document.getElementById("root"));
unregister();
